import React, { useState, useEffect } from 'react';

const cardsData = ['🧠', '🚀', '🧠', '🚀']; // simple pair of emojis

const MemoryGame = () => {
  const [cards, setCards] = useState([]);
  const [flippedIndices, setFlippedIndices] = useState([]);
  const [matched, setMatched] = useState([]);

  useEffect(() => {
    setCards(shuffle([...cardsData]));
  }, []);

  const shuffle = (array) => {
    return array.sort(() => 0.5 - Math.random());
  };

  const handleFlip = (index) => {
    if (flippedIndices.includes(index) || matched.includes(index)) return;
    const newFlipped = [...flippedIndices, index];

    if (newFlipped.length === 2) {
      const [first, second] = newFlipped;
      if (cards[first] === cards[second]) {
        setMatched([...matched, first, second]);
      }
      setTimeout(() => setFlippedIndices([]), 1000);
    } else {
      setFlippedIndices(newFlipped);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-100 to-purple-200 p-4">
      <h1 className="text-3xl font-bold mb-6 text-purple-800">🧠 Memory Match</h1>
      <div className="grid grid-cols-2 gap-6">
        {cards.map((card, idx) => (
          <div
            key={idx}
            onClick={() => handleFlip(idx)}
            className={`w-24 h-24 flex items-center justify-center text-3xl border-4 rounded-xl shadow transition-all duration-300 ${
              matched.includes(idx) || flippedIndices.includes(idx)
                ? 'bg-white'
                : 'bg-purple-400 cursor-pointer'
            }`}
          >
            {(flippedIndices.includes(idx) || matched.includes(idx)) ? card : '❓'}
          </div>
        ))}
      </div>
      {matched.length === cards.length && (
        <div className="mt-8 text-green-700 font-semibold text-xl">🎉 You did it!</div>
      )}
    </div>
  );
};

export default MemoryGame;
